/**
 * @module: 汇总
 * @author: Yawei Wang
 * @date: 2019-06-03 13:51:28
 */
import { getJson, post, postFile, postFileProgress, postJson, postJsonWithJson, putJson, putPureJson, patchPureJson, patch, patchJson, deleteJson, deletePureJson, setCatch, withXsrf } from './ajax';
import { get, set, remove, cookie as cookies } from './cookie';
import { getId, getUuid, getHost, addEvent, removeEvent, offEvent } from './custom';
import { encodeHtml, decodeHtml, removeTag, formatWrapTextOut, formatWrapTextIn } from './html';
import { isEmail, isIdCard, isPhoneNum, isUrl, checkCompanyName, checkUserName } from './rule';
import { getCharLen, getQueryString, getMoney, getSize, deepCopy, throttle, debounce, getObjectURL, urlToLink, getSiteEnv, isMac, isWindow, getSitePreUrl, getDate, downTime, json2QS, qs2JSON } from './utils';
import { saveUrl, saveUrlBlob, download } from './download';
import { isSupportRange, getCurrentRange, getLastChild, insertHtmlAfterRange, placeCaretAtEnd } from './range';
import { NotificationShow, NotificationClose, bindVisiable } from './window';
import { initChild, initParent, toggleDebug, destroy } from './iframe';
import { random_string, getOssDirect, setOssUpload, getOssToken, dataURLtoFile, setOssUpload64 } from './oss';
export const ajax = {
  getJson,
  post,
  postFile,
  postFileProgress,
  postJson,
  postJsonWithJson,
  putJson,
  putPureJson,
  patch,
  patchJson,
  patchPureJson,
  deleteJson,
  deletePureJson,
  setCatch,
  withXsrf
};
export const cookie = {
  get,
  set,
  remove,
  cookies
};
export const custom = {
  getId,
  getUuid,
  getHost,
  addEvent,
  removeEvent,
  offEvent
};
export const fileDownload = {
  saveUrl,
  saveUrlBlob,
  download
};
export const html = {
  encodeHtml,
  decodeHtml,
  removeTag,
  formatWrapTextOut,
  formatWrapTextIn
};
export const iframe = {
  initChild,
  initParent,
  toggleDebug,
  destroy
};
export const range = {
  isSupportRange,
  getCurrentRange,
  getLastChild,
  insertHtmlAfterRange,
  placeCaretAtEnd
};
export const rule = {
  isEmail,
  isIdCard,
  isPhoneNum,
  isUrl,
  checkCompanyName,
  checkUserName
};
export const utils = {
  getCharLen,
  getQueryString,
  getMoney,
  getSize,
  deepCopy,
  throttle,
  debounce,
  getObjectURL,
  urlToLink,
  getSiteEnv,
  isMac,
  isWindow,
  getSitePreUrl,
  getDate,
  downTime,
  json2QS,
  qs2JSON
};
export const window = {
  NotificationShow,
  NotificationClose,
  bindVisiable
};
export const oss = {
  random_string,
  getOssDirect,
  setOssUpload,
  getOssToken,
  dataURLtoFile,
  setOssUpload64
};